import { PlanType } from '../../types';

export const PLAN_LIMITS = {
    [PlanType.FREE]: { members: 0, clients: 1 }, // Fallback for free/test users
    [PlanType.LIGHT]: { members: 0, clients: 20 },
    [PlanType.ADVANCED]: { members: 5, clients: 100 },
    [PlanType.AGENCY]: { members: 10, clients: 250 },
    'premium': { members: 10, clients: 250 }, // Legacy/Alias support
};
